import { Scheduling } from "../models/schedule";
import { Driver } from "../models/driver";
import { cities, states } from "../utils/locationUtils";
import { IAppointmentForm } from "../hooks/useSchedulingForm";
import { Asset } from "../models/asset";
import { CheckupExistsVehicle } from "../api/fetchScheduling";
import { extractContractModality, extractContractNumber } from "../utils/contractUtils";

const isPresent = (value: unknown) => value !== undefined && value !== null && value !== "" && value !== "-";

/**
 * Fills the gaps of an asset with the vehicle data returned by the
 * "checkup exists" endpoint. Values already on the asset win.
 */
export const applyCheckupExistsVehicle = (asset: Asset, vehicle?: CheckupExistsVehicle | null): void => {
  if (!vehicle) return;

  if (!isPresent(asset.licensePlate) && isPresent(vehicle.licensePlate)) asset.licensePlate = vehicle.licensePlate as string;
  if (!isPresent(asset.model) && isPresent(vehicle.model)) asset.model = vehicle.model as string;
  if (!asset.year && vehicle.modelYear) asset.year = vehicle.modelYear;
  if (!isPresent(asset.emissionStandard) && isPresent(vehicle.emissionStandard)) asset.emissionStandard = vehicle.emissionStandard;
  if (!isPresent(asset.group) && isPresent(vehicle.maintenanceGroupId)) asset.group = String(vehicle.maintenanceGroupId);
  if (!asset.odometer && vehicle.odometer) asset.odometer = vehicle.odometer;
  if (!asset.hourmeter && vehicle.hourMeter) asset.hourmeter = vehicle.hourMeter;

  if (vehicle.volkstotal) {
    (asset as any).volkstotal = vehicle.volkstotal;
  }

  const contractNumber = extractContractNumber(asset) ?? extractContractNumber(vehicle);
  if (contractNumber) asset.contractNumber = contractNumber;

  const contractModality = extractContractModality(asset) ?? extractContractModality(vehicle);
  if (contractModality) asset.contractModality = contractModality;
};

export const createAppointmentFormFromScheduling = (scheduling: Scheduling, drivers: Driver[]): IAppointmentForm => {
    const dealershipState = scheduling.dealership?.state ? states.find((state: any) => state.state === scheduling.dealership?.state) : null;

    return {
        assetsAndDrivers: {
            asset: scheduling.asset,
            scheduleByDriver: false,
            checkup: scheduling?.checkup,
            driver: {
                ...scheduling.driver,
                id: (drivers.find((driver: Driver) => driver.email === scheduling.driver?.email))?.id ?? '',
            },
            schedulingTypes: ['preventive'],
            aditionalServices: scheduling?.checkup?.aditionalServices,
            comments: scheduling.comments,
            obs: scheduling.observation,
        },
        dealership: {
            id: scheduling.dealership?.id ?? '',
            name: scheduling.dealership?.name ?? '',
            address: scheduling.dealership?.address ?? '',
            city: scheduling.dealership?.city ?
                cities.find((city: any) => city.name === scheduling.dealership?.city && city.state === dealershipState?.id)?.id : 
                '',
            state: dealershipState ? `${dealershipState.id}_${dealershipState.state}` : '',
            neighborhood: scheduling.dealership?.neighborhood,
            distance: scheduling.dealership?.distance,
            geoLocation: scheduling.dealership?.geoLocation,
        },
        dateAndConsultant: {
            scheduleDate: undefined,
            consultant: undefined,
        }
    };
}